import { render, staticRenderFns } from "./BuyerGuide.vue?vue&type=template&id=188eab58&scoped=true"
import script from "./BuyerGuide.vue?vue&type=script&lang=js"
export * from "./BuyerGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188eab58",
  null
  
)

export default component.exports